"use client"

import PropTypes from "prop-types"
import { getPathOfStatic } from "../utils"
import { useLanguage } from "../../../../contexts/LanguageContext"

const ToolSwitcher = ({ onSwitch }) => {
  const { t } = useLanguage()

  return (
    <div className="toolswitcher">
      <button className="trainer" onClick={() => onSwitch("types")}>
        <img alt="" src={getPathOfStatic("/img/icons/trainer.png") || "/placeholder.svg"} />
        <br />
        {t("trainer")}
      </button>

      <button className="abacus" onClick={() => onSwitch("cards")}>
        <img alt="" src={getPathOfStatic("/img/icons/abacus.png") || "/placeholder.svg"} />
        <br />
        {t("flashCards")}
      </button>
    </div>
  )
}

ToolSwitcher.propTypes = {
  onSwitch: PropTypes.func.isRequired,
}

export default ToolSwitcher
